import TextInput from 'src/app/components/Form/TextInput';

interface DateTextInputType {
  compactStyle?: boolean;
  name: string;
  label: string;
  tabIndex?: number;
}

const DateTextInput = ({ compactStyle, name, label, tabIndex, ...rest }: DateTextInputType) => {
  return (
    <TextInput
      name={name}
      type="tel"
      mask="19/39/Yy99"
      label={label}
      formatChars={{
        '9': '[0-9]',
        Y: '[12]', // for the year, can only do 19XX - 20XX
        y: '[09]', // for the year 2nd digit, can only do 19XX - 20XX
        '1': '[0-1]',
        '3': '[0-3]',
      }}
      compactStyle={compactStyle}
      tabIndex={tabIndex}
      {...rest}
    />
  );
};

export default DateTextInput;
